import type { QueryClient } from '@tanstack/react-query'
import type { ApiClient } from '~/api/apiClient'
import { getValueLabels } from '~/api/endpoints/catalog'

const SEP = '\x1F'

/** Resolve friendly dim-value display labels for a fact table, imperatively. Falls back to the
 *  raw value on miss or catalog failure (no silent-blank: the raw token is always meaningful). */
export async function resolveValueLabelsFor(
  factTable: string,
  deps: { client: ApiClient; queryClient: QueryClient },
): Promise<(dim: string, value: string) => string> {
  const map = new Map<string, string>()
  try {
    const rows = await deps.queryClient.fetchQuery({
      queryKey: ['v_value_labels', factTable] as const,
      queryFn: () => getValueLabels(deps.client, factTable),
      staleTime: Infinity,
    })
    for (const r of rows as Array<{
      dim_name: string
      value: string
      display_label: string | null
    }>) {
      if (r.display_label) map.set(`${r.dim_name}${SEP}${r.value}`, r.display_label)
    }
  } catch {
    // identity resolver below
  }
  return (dim: string, value: string) => map.get(`${dim}${SEP}${value}`) ?? value
}
